import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Common } from "@root/components/common/CommonTypes";
import { Emitter } from "strict-event-emitter";

export default class InternationalCall extends ComponentBase implements Common.InputComponent
{
  iti: any;
  emitter: Emitter<{ change: [value: any, isOk: boolean]; }>;

  _isOk: boolean = false;

  input: HTMLInputElement;

  // mobileOnly: boolean = true;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.emitter = new Emitter();

    this.input = this.$root[0] as HTMLInputElement;    

    this.iti = window.intlTelInput(this.input, {
      initialCountry: "tw",
      nationalMode: true,
      preferredCountries: ["tw"],
      autoInsertDialCode: true,
      // utilsScript: "static/lib/utils.js?1678446285328" // 已改由頁面引入
    });

    this.$root.on("input", () =>
    {
      // console.log("input");

      this.update();
    });

    this.input.addEventListener("countrychange", () =>
    {
      this.update();
    });

    // this.iti.setNumber("");
  }

  update(): void
  {
    this._isOk = this.iti.isValidNumber();

    // console.log(this.iti.getSelectedCountryData());
    // console.log(this.iti.getNumber());
    // console.log(this.getValue());

    this.emitter.emit("change", this.getValue(), this._isOk);
  }

  getValue(): any
  {
    let full: string = this.iti.getNumber(),
      data = this.iti.getSelectedCountryData(),
      number = full.replace(`+${data.dialCode}`, "");

    return {full: full, area_code: number, iso2: data.iso2, dial_code: data.dialCode, name: data.name};
  }

  setValue(value: string)
  {
    this.iti.setNumber(value);
    this.update();
  }

  isOk(): boolean
  {
    return this._isOk;
  }

  reset(): void
  {
    this.iti.setNumber("");
    this.update();
  }
}